"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const StackNavigationContext_1 = require("../../contexts/StackNavigationContext");
const StackNavigationView_1 = require("./StackNavigationView");
class NestedStackNavigationView extends React.PureComponent {
    constructor() {
        super(...arguments);
        this._renderNested = (parentContext) => {
            const childProps = { ...this.props, parentContext };
            return React.createElement(StackNavigationView_1.StackNavigationView, childProps);
        };
    }
    render() {
        return React.createElement(StackNavigationContext_1.StackNavigationContextConsumer, null, (parentContext) => this._renderNested(parentContext));
    }
}
exports.NestedStackNavigationView = NestedStackNavigationView;
